// Elements 
import Footer from './footer';
import Header from './header';
import Contactform from './contact-form'
import React, { useRef, useEffect, useState } from 'react';
// GaSP
import gsap from 'gsap'
import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/all';
import SplitType from 'split-type'

// Bootstrap
// import Col from 'react-bootstrap/Col';
// import Form from 'react-bootstrap/Form';
// import Button from 'react-bootstrap/Button';

// Images
import about01 from '../assets/About/banner-01.webp'
import about03 from '../assets/About/banner-03.webp'
import about04 from '../assets/About/banner-04.webp'
import about05 from '../assets/About/banner-05.webp'
import about06 from '../assets/About/banner-06.webp'
import about07 from '../assets/About/banner-07.webp'





// CSS
import '../aboutus.css'
// import banner_01 from '../assets/Banner_01.webp'

// Videos
import aboutpromovideo from '../assets/About/pintdspromo.webm'
import pintvideos from '../assets/About/pintsvideos.mp4'



gsap.registerPlugin(ScrollTrigger) 

function About() {


    const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'horizontal', // vertical, horizontal
        gestureDirection: 'horizontal', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

    useGSAP(() => {

        let h1 = new SplitType('.h1.smaller', {
          types: 'words',
          tagName: 'span'
        });

        let p = new SplitType('.is--about--hero--2 p', {
            types: 'lines',
            tagName: 'span'
          });

        gsap.from(h1.words, {
            y: '100%',
            opacity: 1,
            duration: 0.1,
            ease: 'power1.inOut',
            stagger: 0.1,
            
          });

          gsap.from(p.lines, {
            y: '100%',
            opacity: 0,
            duration: 0.1,
            ease: 'power1.inOut',
            stagger: 0.1,
          });


             
          let fadein = gsap.utils.toArray('.anime-scroll')
          fadein.forEach((item, index) => {
          
          let tl = gsap.timeline({
            scrollTrigger: {
            trigger: item,
          //   pin: true,
            start: "top center",
            end: "bottom bottom",
            scrub: .6,
            toggleActions:"restart none none reset",
            }
          });

          let animescroll = new SplitType(item, {
            types: 'chars',
            tagName: 'span'
          });
          tl.from(animescroll.chars, {
            opacity: 0,
            duration: 0.1,
            ease: 'Second.in',
            stagger: 0.1,
            });
          });
      
    })
    

 
    return (
        <section className='paint-container about-container' id="smooth-wrapper">
           <Header/>
           <main className="page-main">
    <section className="home-content_section">
        <div className="home-content_visual"><img src={about01} alt={about01} className="home-content_image"/></div>
        <div className="home-content_text-wrap">
            <div className="page-padding is-home-content">
                <div className="about-us-heading-wrapper">
                    <h1 className="h1 smaller">Pouring Pints Pvt. Ltd.</h1>
                </div>
                <div className="paragraph-wrapper is--about--hero--2">
                    <p className="p-text white top-margin">At <b>Pouring Pints Pvt. Ltd.</b>, we are passionate about crafting exceptional beer experiences. Since our inception, we have been dedicated to helping businesses brew their own craft beer while we handle the complexities of brewery management. Our mission is simple: You reap the rewards, we handle the brewing.</p>
                    <p className="p-text white top-margin">With a team of award-winning brewmasters, skilled microbiologists, and engineering experts, we bring over a decade of brewing excellence to your doorstep. Whether you’re a seasoned F&B outlet or a new entrant in the craft beer scene, we provide tailored solutions to ensure your brewery thrives.</p>
                </div>
            </div>
        </div>
    </section>
    <div className="section-home-intro-2">
        <div className="padding-custom-2 is--home--intro">
            <div className="container-large">
                <div className="home-intro-content _1">
                    <div className="card-heading-text is--docs">
                        <div className="intro-content is--top">
                            <div className="container-large-4">
                                <div className="intro-block _1">
                                   
                                    <div className="home-intro-paragraph-wrapper">
                                    <h2 className="section-heading is--about">
                                    Our Brewing Philosophy
                                    </h2>
                                        <p className="p-text top-margin is--about anime-scroll">
                                            At Pouring Pints, we believe that great beer is a blend of art, science, and passion. From selecting the finest grains to perfecting the fermentation process, we ensure every pint poured is a testament to our commitment to quality.
                                        </p>
                                   </div>

                                   {/* <div className="grid-block p-2">
                            <div className="img-wrapper home-intro block-image-2"></div>
                        </div> */}

                                   <div className="home-intro-paragraph-wrapper">
                                        <h2 className="section-heading is--about anime-scroll">Our brewing<br/>process:</h2>
                                      
                                        <p className="p-text top-margin is--about anime-scroll">Deliver consistent, high-quality beer that delights your customers.
                                          Optimize operations to reduce costs and increase efficiency.
                                          Create a unique beer portfolio that sets your brand apart.</p>
                                        
                                   </div>
                                  

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="home-intro-content _2" id="video-container">
                    <div className="w-layout-grid _2-column">
                        <div className="grid-block anime-scroll">
                            <div className="img-wrapper home-intro">
                            <video className="image-full is--laptop"  
                            sizes="(max-width: 479px) 100vw, 98vw" 
                            autoplay 
                            muted 
                            loop 
                            controls
                            >
                       <source src={aboutpromovideo} type='video/mp4' />
                   </video>

                   {/* <button type="button" id="play_button"><img src="https://static.thenounproject.com/png/117815-200.png"/>
</button> */}
                            </div>
                        </div>
                        <div className="grid-block is--right">
                            <div className="home-intro-content-grid">
                                <div className="about-intro-heading-container">
                                    <h3 className="section-heading is--h3 anime-scroll">
                                    Join the Craft <br/>Beer Revolution
                                    </h3>
                                </div>
                                <div className="home-intro-paragraph-wrapper">
                                    <p className="p-text top-margin is--about anime-scroll">Whether you’re looking to set up a new microbrewery or enhance an existing one, Pouring Pints is your trusted partner. With our expert guidance, tailored solutions, and unwavering commitment to excellence, we help you turn your craft beer vision into a resounding success.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="section-about-video">
        <div className="padding-custom is--about--video">
            <div className="background-video w-background-video w-background-video-atom">
                    
                      <video className="image-full is--laptop" sizes="(max-width: 479px) 100vw, 98vw" autoPlay loop muted>
                         <source src={pintvideos} type='video/mp4' />
                     </video>
                <div className="overlay-video-bg">
                    <div className="about-intro-video-top-content">
                        <h2  className="h2 text-align-left smaller anime-scroll">
                        Our Commitment to<br/>Sustainability
                        </h2>
                    </div>
                    <div className="about-intro-video-bottom-content">
                        <p className="p-text white top-margin anime-scroll">We are dedicated to sustainable brewing practices that minimize environmental impact. From energy-efficient brewing systems to waste reduction strategies, we ensure your brewery operates responsibly while delivering exceptional beer.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="section-home-process">
        <div className="cards is--desktop">
            <div className="css-marquee w-embed"></div>
            <div className="card-heading is--desktop is--cards">
                <div className="card-heading-wrapper">
                    <div className="card-container">
                        <div className="card-heading-text is--center">
                            <h2 className="section-heading text-align-center smaller anime-scroll">
                            Why Us?
                                </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div data-w-id="4bba0e48-6c72-0f36-9ff1-ab4110eec071" className="cards-scroller">
                <div className="sticky-viewbox">
                    <div className="cards-wrapper">
                        <div className="card-half left">
                            <div className="card-slide color-1">
                                <div className="card-image-mobile">
                                    <div className="slide-content-2"><img
                                            src={about03}
                                            loading="lazy" alt="" className="full-image"/></div>
                                </div>
                                <div className="slide-content-2 _1">
                                    <h3 className="h3 text-align-left is--scroll">Expertise That Brews Success</h3>
                                    <div className="snap-content">
                                        <div className="snap-top">
                                            <p className="p-text white top-margin is--scroll">Our team comprises masters in microbiology, brewing, distilling, mechanical engineering, chemical engineering, and commercial packaging. With experience from renowned brands like Toit and Byg Brewsky, our brewmasters design recipes that stand out in flavor, quality, and innovation.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-slide color-2">
                                <div className="card-image-mobile">
                                    <div className="slide-content-2"><img
                                            src={about04}
                                            alt="" className="full-image"/></div>
                                </div>
                                <div className="slide-content-2 _1">
                                    <h3 className="h3 text-align-left is--scroll">Award-Winning Recipes</h3>
                                    <div className="snap-content">
                                        <div className="snap-top">
                                            <p className="p-text white top-margin is--scroll">From crisp Czech Pilsners to bold IPAs and refreshing Raspberry Gose, our portfolio boasts over 100 unique beers. Each recipe is crafted to perfection, ensuring your brewery offers a diverse and exciting range of craft beers.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-slide color-2">
                                <div className="card-image-mobile">
                                    <div className="slide-content-2"><img
                                           src={about05}
                                            alt="" className="full-image"/></div>
                                </div>
                                <div className="slide-content-2 _1">
                                    <h3 className="h3 text-align-left is--scroll">Seamless Brewery Management</h3>
                                    <div className="snap-content">
                                        <div className="snap-top">
                                            <p className="p-text white top-margin is--scroll">Running a brewery in a fast-paced F&B environment can be challenging. We eliminate the hassle by managing your brewery operations with precision, ensuring high-quality beer, optimized processes, and maximized output.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-slide color-2">
                                <div className="card-image-mobile">
                                    <div className="slide-content-2"><img
                                           src={about06}
                                            alt="" className="full-image"/></div>
                                </div>
                                <div className="slide-content-2 _1">
                                    <h3 className="h3 text-align-left is--scroll">Tailored Solutions for Your Brand</h3>
                                    <div className="snap-content">
                                        <div className="snap-top">
                                            <p className="p-text white top-margin is--scroll">We understand that every brewery is unique. That’s why we offer customized strategies to align with your brand’s vision, ensuring measurable results and sustainable growth.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-slide color-3">
                                <div className="card-image-mobile">
                                    <div className="slide-content-2"><img
                                            src={about07}
                                            loading="lazy" alt="" className="full-image"/></div>
                                </div>
                                <div className="slide-content-2 _1">
                                    <h3 className="h3 text-align-left is--scroll">End-to-End Support</h3>
                                    <div className="snap-content">
                                        <div className="snap-top">
                                            <p className="p-text white top-margin is--scroll">From excise management to commercial packaging, we provide comprehensive support to streamline your operations. Our collaborative approach ensures long-term success and profitability for your brewery.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-half right">
                            <div className="card-slide">
                                <div className="slide-content-2"><img
                                       src={about03}
                                        alt="" className="full-image"/></div>
                            </div>
                            <div className="card-slide">
                                <div className="slide-content-2"><img
                                        src={about04}
                                        alt="" className="full-image"/></div>
                            </div>
                            <div className="card-slide">
                                <div className="slide-content-2"><img
                                       src={about05}
                                        alt="" className="full-image"/></div>
                            </div>
                            <div className="card-slide">
                                <div className="slide-content-2"><img
                                      src={about06}
                                        alt="" className="full-image"/></div>
                            </div>

                            <div className="card-slide">
                                <div className="slide-content-2"><img
                                     src={about07}
                                        alt="" className="full-image"/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Contactform/>

 
</main>
           <Footer/>
        </section>
    )}

export default About;    